<template>
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[showBanner ? $style.rotateArrow: '']">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.96967 0.71967C1.26256 0.426777 1.73744 0.426777 2.03033 0.71967L5 3.68934L7.96967 0.71967C8.26256 0.426777 8.73744 0.426777 9.03033 0.71967C9.32322 1.01256 9.32322 1.48744 9.03033 1.78033L5.53033 5.28033C5.23744 5.57322 4.76256 5.57322 4.46967 5.28033L0.96967 1.78033C0.676777 1.48744 0.676777 1.01256 0.96967 0.71967Z"
            fill="#1E242C" />
    </svg>
</template>
<script>
export default {
    props: {
        showBanner: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" module>
    .rotateArrow {
        transform: rotate(180deg);
    }
</style>